import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

export const preferredRelationsShipsQuerySchema = z.object({
  id: z.number(),
  name: z.string(),
  status: statusQuerySchema,
});

export type PreferredRelationsShipsQuerySchema = z.infer<typeof preferredRelationsShipsQuerySchema>;

export const preferredRelationsShipsQuerySchemaAllSchema = paginatedResponseSchema(preferredRelationsShipsQuerySchema);
export type PreferredRelationsShipsQuerySchemaAllSchema = z.infer<typeof preferredRelationsShipsQuerySchemaAllSchema>;
